import React from 'react';

import type { CliveMood } from '~/components/Clive/cliveRegistry';
import { CLIVE_AVATARS, CLIVE_MOODS } from '~/components/Clive/cliveRegistry';
import type { IconProps } from '~/components/icons/types';

interface CliveAvatarProps extends IconProps {
  mood?: CliveMood;
}

export const CliveAvatar: React.FC<CliveAvatarProps> & { MOOD: typeof CLIVE_MOODS } = Object.assign(
  ({ mood = CLIVE_MOODS.HAPPY, ...props }: CliveAvatarProps) => {
    const Icon = CLIVE_AVATARS[mood];
    return Icon ? <Icon {...props} /> : null;
  },
  { MOOD: CLIVE_MOODS }
);
